import React, { useState, useEffect } from "react";
import axios from '../helper/axios';
import Autocomplete from "@mui/material/Autocomplete";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useUser } from "../Provider";


const SearchFloor = ({ onFloorChange, hospitalvalue }) => {
    const { userrole1, token } = useUser();
    const [data,setFloorNames] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [openAutocomplete, setOpenAutocomplete] = useState(false);

    useEffect(() => {
        fetchFloorNames();
        setSelectedCategory('');
    }, [hospitalvalue, userrole1]);

    const fetchFloorNames = async () => {
        try {
          const response = await axios.get("/getfloornames", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: {
              hospitalcode:hospitalvalue,
            },
          });
    
          if (response.status === 200) {
            setFloorNames(response.data);
          } else {
            console.error(`Failed to fetch available floor numbers with status: ${response.status}`);
          }
        } catch (error) {
          console.error('Error fetching available floor numbers:', error.message);
        }
      };

    const handleCategoryChange = (event, value) => {
      if (value) {
        setSelectedCategory(value);
        onFloorChange(value);
    } else {
        // Handle the case when no value is selected
        setSelectedCategory('');
    }
    };
    const getOptionLabel = (option) => {
      // Handle the case when option is null or undefined
      return option?.floorname || '';
  };

  const handleExpandClick = () => {
    setOpenAutocomplete(!openAutocomplete);
};
    return (
        <div className="searchbar">
            <Autocomplete
                freeSolo
                id="free-solo"
                options={data}
                getOptionLabel={getOptionLabel}
                open={openAutocomplete}
                onOpen={() => setOpenAutocomplete(true)}
                onClose={() => setOpenAutocomplete(false)}
                value={selectedCategory}
                onChange={handleCategoryChange}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        placeholder="Select Floor"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleExpandClick}>
                                        <ExpandMoreIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                }
            />
        </div>
    );
};

export default SearchFloor;
